import { Controller } from "@hotwired/stimulus"
import type { TurboBeforeFetchRequestEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"
import SelectionToolbarController from "../selection_toolbar_controller"

export default class extends Controller {
  static targets = ["deleteSelectedBtn", "toolbar"]

  declare readonly deleteSelectedBtnTarget: HTMLButtonElement
  declare readonly toolbarTarget: HTMLElement

  // Individual delete confirmation
  async confirmDelete(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmDelete("this autoreply")) {
      event.detail.resume(null)
    }
  }

  // Bulk delete confirmation and ID injection
  deleteSelectedBtnTargetConnected(el: HTMLButtonElement) {
    const form = el.closest("form")
    if (!form) return

    form.addEventListener("turbo:before-fetch-request", async (event: TurboBeforeFetchRequestEvent) => {
      event?.preventDefault()

      const selectionToolbar = this.getSelectionToolbarController()
      const ids = selectionToolbar?.selectedIds() || []
      const count = ids.length

      if (await Confirmation.confirm({
        text: `Are you sure you want to delete ${count} ${count === 1 ? 'autoreply' : 'autoreplies'}?`,
        confirmButtonText: "Yes, delete!",
        type: "danger"
      })) {
        event.detail.resume(null)
      } else {
        selectionToolbar?.clearSelected()
      }
    })

    form.addEventListener("turbo:submit-start", (event: TurboSubmitStartEvent) => {
      const selectionToolbar = this.getSelectionToolbarController()
      const ids = selectionToolbar?.selectedIds() || []
      ids.forEach(id => {
        event.detail.formSubmission.fetchRequest.body.append("ids[]", id)
      })
    })
  }

  getSelectionToolbarController(): SelectionToolbarController | null {
    return SelectionToolbarController.getInstance(this.toolbarTarget)
  }
}
